module.exports = __webpack_public_path__ + "img/pro_two_5.f6000fd9.jpg";